import { useAudioMeter } from '../hooks/useAudioMeters';

interface VUMeterProps {
  trackId?: string; // undefined = master
  orientation?: 'vertical' | 'horizontal';
  size?: 'compact' | 'normal';
}

const SEGMENTS = 12;
const GREEN_THRESH = 0.6;
const YELLOW_THRESH = 0.85;

function getSegmentColor(index: number, total: number): string {
  const normalized = index / total;
  if (normalized > YELLOW_THRESH) return '#ef4444'; // red
  if (normalized > GREEN_THRESH) return '#eab308'; // yellow
  return '#07E5B0'; // green
}

export function VUMeter({ trackId, orientation = 'vertical', size = 'compact' }: VUMeterProps) {
  const { rms, peak } = useAudioMeter(trackId);

  const activeSegments = Math.round(rms * SEGMENTS);
  const peakSegment = Math.round(peak * SEGMENTS);

  if (orientation === 'horizontal') {
    const barWidth = size === 'compact' ? 60 : 120;
    const barHeight = size === 'compact' ? 4 : 8;

    return (
      <div className="flex items-center gap-px" style={{ width: barWidth, height: barHeight }}>
        {Array.from({ length: SEGMENTS }, (_, i) => (
          <div
            key={i}
            className="flex-1 rounded-sm transition-opacity duration-75"
            style={{
              height: '100%',
              backgroundColor: getSegmentColor(i, SEGMENTS),
              opacity: i < activeSegments ? 1 : i === peakSegment ? 0.6 : 0.15,
            }}
          />
        ))}
      </div>
    );
  }

  // Vertical
  const barWidth = size === 'compact' ? 4 : 8;
  const barHeight = size === 'compact' ? 20 : 40;

  return (
    <div className="flex flex-col-reverse items-center gap-px" style={{ width: barWidth, height: barHeight }}>
      {Array.from({ length: SEGMENTS }, (_, i) => (
        <div
          key={i}
          className="w-full rounded-sm transition-opacity duration-75"
          style={{
            flex: 1,
            backgroundColor: getSegmentColor(i, SEGMENTS),
            opacity: i < activeSegments ? 1 : i === peakSegment ? 0.6 : 0.15,
          }}
        />
      ))}
    </div>
  );
}
